var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M12 11C6.477 11 2 15.477 2 21h20c0-5.523-4.477-10-10-10Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 6,
  r: 5
}))));
export default SvgPersonIcon;